<template>
    <div id="container-navbar" class="h-full" :class="[route.name == 'Store' || route.name == 'News' ? [' shadow-white', 'shadow-card-v3', 'dark:shadow-primary-dark-color-2nd', 'max-md:shadow-none'] : '']">
        <div id="desk-navbar" v-if="!store.isMovil" class="flex justify-end h-full bg-gray-light dark:bg-primary-dark-color-2nd">
            <div v-if="!store.getIsPP()" id="logo-container" class="flex fixed z-40 left-0 w-10% pl-special pt-min h-logo-desktop hover:cursor-pointer">
                <img class="object-contain w-full h-full p-middle" @click="nav('back', null)" id="ccj-logo" :src="URL_LOGO" alt="CCJ MEDIOS LOGO">
            </div>
            <div id="container-menus" :class="[store.getIsPP() ? 'w-full' : 'w-menu-desktop']">
                <div id="container-principal-menu" class="light-menu z-10 relative shadow-menu shadow-black-12 dark:dark-menu" :class="[route.name != 'Store' && route.name != 'News' && route.name != 'Modal' && route.name != 'ModalT' ? 'h-full' : 'h-menu-desk']">
                    <div id="container-option" class="h-full flex w-full justify-end">
                        <RouterLink class="flex flex-wrap content-center h-auto p-special text-principal-desktop dark:text-primary-dark-text" v-for="option in t('menu', { returnObjects: true })" @click="(nav('go', option.path))" :to="option.path" :class="[option.path == actual ? ['bg-primary-color-1st', 'text-white', 'font-bloggerB', 'dark:bg-primary-dark-color-1st'] : 'font-bloggerM']">
                            {{ (option.option) }}
                        </RouterLink>
                        <markShoppingCart class="max-md:pr-special" />
                        <Config />
                    </div>
                </div>
                <submenu />
            </div>
        </div>
        <div v-if="store.isMovil" id="mobile-navbar" class="flex flex-col h-full content-center flex-wrap">
            <div id="container-menus" class="w-11/12 relative bg-white shadow-lg-top shadow-black-menu p-special rounded-smoth dark:bg-primary-dark-color-4th dark:bg-none dark:shadow-card-v4 dark:shadow-primary-dark-color-2nd">
                <div id="container-option" class="h-full flex w-full justify-between items-center">
                    <RouterLink v-if="route.name != 'principalPage'" class="flex h-full font-bloggerM px-text text-principal-desktop w-1/6 text-secondary-color-3rd dark:text-primary-dark-text" @click="(nav('go', '/'))" to="/">
                        <div class="w-full flex flex-col items-center justify-center">
                            <div class="w-1/2 mb-min h-7">
                                <font-awesome-icon icon="home" class="w-full h-full " />
                            </div>
                            <div class="w-full text-center font-bloggerM">
                                {{ t('Main') }}
                            </div>
                        </div>
                    </RouterLink>
                    <RouterLink class="flex h-full font-bloggerM px-text text-principal-desktop w-1/6 text-secondary-color-3rd dark:text-primary-dark-text" v-for="option in t('menu', { returnObjects: true })" @click="(nav('go', option.path))" :class="[option.path == actual ? 'hidden' : '']" :to="option.path" :id="option.option">
                        <div class="w-full flex flex-col items-center justify-center">
                            <div class="w-1/2 mb-min h-7">
                                <font-awesome-icon :icon="option.icon" class="w-full h-full" />
                            </div>
                            <span class="w-full text-center font-bloggerM">
                                {{ option.option }}
                            </span>
                        </div>
                    </RouterLink>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import Config from '../utils/Config.vue';
import router from '@/router';
import { ref } from 'vue';
import { RouterLink } from 'vue-router';
import { useTranslation } from 'i18next-vue';
import { generalStore } from '@/stores';
import { watchEffect } from 'vue';

import submenu from '../subcomponents/Submenu.vue';
import markShoppingCart from '../subcomponents/ShoppingCart.vue';

const URL_LOGO = import.meta.env.VITE_LOGO;
const store = generalStore();
const route = store.route;
const { t } = useTranslation();


var actual = ref('');

watchEffect(() => {
    if (route.path && route.name != 'Preview' && route.name != 'Modal' && route.name != 'ModalT') {
        actual.value = route.path;
    }
})

/**
 * Function used to navigate to the destination link
 * @param path Is the next path route
 * @param action Is action (Go o Back)
 */
const nav = (action, path) => {
    if (actual.value != path) {
        store.filterN = false;
        store.filterC = false;
        store.notFound = false;
        store.setSubMenu(null)
        store.removeLocalStorage('submenu')
    }

    if (action == 'back') {
        router.push({ path: '/' })
    }
}
</script>